import { useMemo } from 'react';
import { useNavigationContext } from '../context/NavigationContext';
import { SectionData } from '../data/Sections';

export default function useSection(sectionID: string): SectionData
{
  const { sections } = useNavigationContext();

  return useMemo(() => {
    for (const section of sections) {
      if (section.id === sectionID) {
        return section;
      }
    }
    return {
      active: false,
      // this keeps track of how far we are in each section
      ratio: 0,
      id: '',
      relativeDuration: 0,
      startDelay: 0,
      start: 0,
      end: 0,
      snapPoints: [0, 1]
    };
  }, [sections, sectionID]);
}